import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=d45a3d4a&scoped=true"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=d45a3d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45a3d4a",
  null
  
)

export default component.exports